import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import BodyText from "../../elements/body-text";
import AccountOverviewForm from "../form-overview-section";
import { S_MEMBERCREATE_CONTRACTID, webStorage } from "../../utils/webStorage";
import api from "../../utils/api";

import { memberCreate } from "../../services/member";
import { presalesOrderDetails } from "../../utils/processesOrderDetails";
import { selectUserState } from "../../selectors/application";
import { setUserInfoAction } from "../../redux/actions";
import { getUserInfo } from "../../services/userService";

const PreSalesOnlineOrderConfirmation = ({ lang, fields, history, orderId, queryInStore, queryMembership, user, setUserInfo, summaryCommons }) => {
  const { headingType, headingBody, body, labels, level0Label, level12Label } = fields;
  let unloadStatus = false;
  const [orderData, setOrderData] = useState([]);
  const [heading, setHeading] = useState({
    type: headingType,
    html: JSON.parse(JSON.stringify(headingBody))
  });
  useEffect(() => {
    // get order data from API
    // here faked with fakeOrderData
    getData();
    return () => {
      unloadStatus = true;
    };
  }, []);
  const getData = async () => {
    // 967 618027419391102976
    // console.log(creatingClues)
    if (queryInStore && queryMembership) {
      level3Date();
    }
    if (!summaryCommons) return;
    const { membershipCode } = summaryCommons;
    if (membershipCode === "MEMBERSHIP04") {
      level3Date();
    } else {
      getLabel();
      changeUserLevel();
    }
    return () => {
      unloadStatus = true;
    };
  };
  const setCountryLang = async () => {
    if (lang?.toLocaleLowerCase() === "en") {
      user.membershipCode = summaryCommons?.membershipCode;
      setUserInfo(user);
      return null;
    }
    let countryLang = null;
    try {
      countryLang = await api.site.get(null, { key: lang });
      await api.user.countrylang.update(null, {
        preferredCountry: countryLang?.CountryLocal,
        preferredLanguage: countryLang?.CountryLang,
        userAccount: user?.userAccount
      });
      const newUser = await getUserInfo();
      setUserInfo(newUser);
    } catch (err) {
      console.dir(err);
    }
  };
  const changeUserLevel = async evt => {
    const contractId = webStorage.get(S_MEMBERCREATE_CONTRACTID) || "";
    if (user && summaryCommons?.membershipCode && user.membershipCode !== summaryCommons.membershipCode && ["MEMBERSHIP01", "MEMBERSHIP02", "MEMBERSHIP03"].includes(user.membershipCode)) {
      try {
        await api.user.membership.update(null, {
          userAccount: user.userAccount,
          membershipLevel: summaryCommons?.membershipCode
        });
        if (contractId) {
          memberCreate({
            contractId: contractId,
            surname: user.lastName,
            firstName: user.firstName,
            emailAddress: user.email,
            isEmailOptout: user.subscribed,
            membership: user.membershipCode
          }).then(() => {
            webStorage.clear(S_MEMBERCREATE_CONTRACTID);
          });
        }
        await setCountryLang();
      } catch (ex) {
        // setSubmitError(true);
      }
    }

    /*
    contiue to next step ...
    level 0-2 update mmebship to backend
    level 3 contiune to become a member flow and checkout.
    */

    // if request fail setSubmitError(true)

    // on success close modal
  };
  const getLabel = () => {
    let currentLevelList = [],
      labelResultList = [];
    const membershipCode = summaryCommons ? summaryCommons.membershipCode : "";

    if (membershipCode === "MEMBERSHIP01") {
      currentLevelList = level0Label;
    } else if (membershipCode === "MEMBERSHIP02" || membershipCode === "MEMBERSHIP03") {
      currentLevelList = level12Label;
    }
    (currentLevelList || []).forEach((item, index) => {
      let labelKey = (item && item.fields && item.fields.key.value) || "";
      let labelValue = "";
      switch (labelKey) {
        case "orgName":
          labelValue = summaryCommons.country;
          break;
        case "memberShip":
          labelValue = summaryCommons.membership;
          break;
        case "color":
          labelValue = summaryCommons.color?.preSelectValue?.value;
          break;
        case "engine":
          labelValue = summaryCommons.engine?.preSelectValue?.value;
          break;
        case "customerNumber":
          labelValue = summaryCommons.customerNumber || user?.customerNumber;
          break;
        case "orderDeposit":
          labelValue = summaryCommons.formattedPrice;
          break;
        default:
      }
      labelResultList.push({
        label: item.fields.phrase.value,
        value: labelValue
      });
    });
    if (!unloadStatus) {
      setOrderData(labelResultList);
    }
  };
  const level3Date = async () => {
    //"114" "8AD21CA75821000"
    let node = document.createElement("div");
    node.innerHTML = headingBody ? headingBody.value : "";
    const { orderDetail, orderData } = await presalesOrderDetails({
      orderId: orderId,
      membership: summaryCommons?.membership || queryMembership,
      labels: labels,
      lang: lang,
      inStore: queryInStore
    });
    if (node.firstChild) {
      node.firstChild.innerText += " " + orderDetail?.orderNo;
      heading.html.value = node.innerHTML;
      setHeading(heading);
    }
    setOrderData(orderData);
  };

  return (
    <>
      <AccountOverviewForm heading={heading} items={orderData} />
      <BodyText html={body.value} className="message" />
    </>
  );
};
const mapStateToProps = state => ({
  user: selectUserState(state),
  summaryCommons: state.becomeAMemberSummary
});
const mapDispatchToProps = dispatch => ({
  setUserInfo: data => dispatch(setUserInfoAction(data))
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PreSalesOnlineOrderConfirmation));
